<template>
  <v-expansion-panels class="w-form" v-model="openedPanel" accordion>
    <v-expansion-panel>
      <v-expansion-panel-header class="tit-lev1">Tug-Boat: [{{ tugBoat }}]- Date: [{{ movDate }}]
         <v-spacer />
        <v-btn class="mr-2" small depressed color="primary" max-width="80px" @click.native.stop="btnChiefConfirm" v-if = "btnChief" > <span class="caption ">C/E sign</span> </v-btn> 
        <v-btn small depressed color="primary" max-width="80px" @click.native.stop="btnCaptionConfirm" v-if = "btnCaption"> <span class="caption ">Cap't sign</span> </v-btn>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-expansion-panels v-model="cOpenedPanel" accordion>
          <!-- Tug-Boat -->
          <v-expansion-panel>
            <v-expansion-panel-header>Tug-Boat: {{ tugBoat }}</v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-select label="Select" v-model="cboTugBoat" :items="listTugBoat" :item-value="`code`" :item-text="`name`" @change = "btnSearch()"></v-select>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <!-- Moving Date -->
          <v-expansion-panel>
            <v-expansion-panel-header>Movement Date: {{ movDate }}</v-expansion-panel-header>
            <v-expansion-panel-content>
              <div class="xy-center">
                <div class="mr-2">
                  <v-menu ref="fromDate" :close-on-content-click="false" :return-value.sync="movDate" offset-y min-width="290px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="movDate" label="Moving Date" readonly v-bind="attrs" v-on="on" hide-details />
                    </template>
                    <v-date-picker v-model="movDate" no-title scrollable>
                      <v-spacer />
                      <v-btn text @click="$refs.fromDate.isActive = false">
                        Cancel
                      </v-btn>
                      <v-btn text @click="$refs.fromDate.save(movDate)">
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </div>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <!-- Tug-Boat Copy-->
          <v-expansion-panel>
            <v-expansion-panel-header>Tug-Boat To: {{ tugBoatCopy }}
             <v-spacer />
            <v-btn  small depressed color="primary" max-width="60px" @click.native.stop="btnCopy"> <span class="caption ">Copy To</span> </v-btn>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-select label="Select" v-model="cboTugBoatCopy" :items="listTugBoat" :item-value="`code`" :item-text="`name`" ></v-select>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <!-- End of search condition area -->
    <v-divider></v-divider>
    <!-- List information -->
    <!-- Start search result area -->
    <v-expansion-panel>
      <v-expansion-panel-header class="tit-lev1">
        Result: {{ listSize === 0?'No Data!': listSize }}
        <v-spacer />
        <v-btn  v-if="writeYn" small depressed color="primary" max-width="60px" @click.native.stop="btnAdd"> <span class="caption ">Add</span> </v-btn>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-text-field
          class="mt-2"
          label="Filter"
          prepend-inner-icon="mdi-magnify"
          outlined
          clearable
          clear-icon="mdi-close-circle-outline"
          v-model="txtFilter"
          hide-details
          small
        />
        <v-list nav dense>
          <v-list-item-group>
            <v-divider />
            <v-virtual-scroll bench="50" :items="filteredItems" height="calc(100vh - 270px)" item-height="250">
              <template v-slot:default="{ index, item }">
                <v-list-item :key="index">
                  <v-list-item-title @click="listItemClick(item)" style="text-overflow: ellipsis; white-space:nowrap; overflow:hidden;">
                       <tr>                  
                        <td style="width: 150px"><v-chip color="green" dark small >{{ item.id }}</v-chip></td>
                        <td>                          
                          <v-btn  v-if="writeYn" class="ma-1" small depressed color="primary" max-width="60px" @click.native.stop="btnDelete(item)">
                            <span class="caption ">Delete</span>
                          </v-btn>
                        </td>
                      </tr> 
                      <tr>                  
                        <td style="width: 150px"><strong>Ship No: </strong></td><td><span>{{ item.shipno }}</span> </td>
                      </tr> 
                      <tr>                  
                        <td style="width: 150px"><strong>Ship Name: </strong></td><td><span>{{ item.shipnm }}</span> </td>
                      </tr>  
                      <tr>                  
                        <td style="width: 150px"><strong>Start date/time: </strong></td><td><span>{{ item.fday }} / {{ item.fhhmm }}</span> </td>
                      </tr>  
                      <tr>                  
                        <td style="width: 150px"><strong>Finish date/time: </strong></td><td><span>{{ item.tday }} / {{ item.thhmm }}</span> </td>
                      </tr> 
                      <tr>                  
                        <td style="width: 150px"><strong> Oil Consumption: </strong></td><td><span>{{ item.oiltime }}</span> </td>
                      </tr> 
                      <tr>                  
                        <td style="width: 150px"><strong>Place: </strong></td><td><span>{{ item.fjangso }} ~ {{ item.tjangso }}</span> </td>
                      </tr>  
                      <tr>                  
                        <td style="width: 150px"><strong>Bunker: </strong></td><td><span>{{ item.bunker }}</span> </td>
                      </tr>  
                      <tr>                  
                        <td style="width: 150px"><strong>Purpose: </strong></td><td><span>{{ item.mcode }}</span> </td>
                      </tr>
                      <tr>                  
                        <td style="width: 150px"><strong>Fuel Oil: </strong></td><td><span>{{ item.fueloil ==='M'?'Ship moving':'Support'}}</span> </td>
                      </tr> 
                      <tr>                  
                        <td style="width: 150px"><strong>Remark: </strong></td><td><span>{{ item.rmk }}</span> </td>
                      </tr> 
                  </v-list-item-title>
                </v-list-item>
                <v-divider :key="item.shipno + index" />
              </template>
            </v-virtual-scroll>
          </v-list-item-group>
        </v-list>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <!-- End of search result area -->
    <!-- Start detailed dialog -->
    <v-dialog fullscreen persistent v-model="showDetail">
      <v-card>
        <v-toolbar height="55px" class="app_bar_bg" color="primary" dark> 
          <v-chip color="green" dark small >{{ itemDetail.id }}</v-chip>
          <v-spacer />
          <v-btn icon>
            <v-icon @click="showDetail = false">mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-sheet style="overflow-x: auto; overflow-y: auto" max-height="calc(100vh - 55px)">
          <div class="pt-3 mr-3" style="display: flex; justify-content: end;">
            <v-btn  v-if="writeYn" small color="primary" class=" mr-2" @click="btnSave">
              Save
            </v-btn>
          </div>
          <v-simple-table style="white-space: normal; word-wrap: break-word; word-break: break-all;">
            <template v-slot:default>
              <tbody>
                <tr>
                  <td style="width: 100px">
                    <strong>Tug-Boat</strong>
                  </td>
                  <td>
                    <v-autocomplete
                      v-model="itemDetail.tugno"
                      :items="listTugBoat"
                      :item-value="`code`"
                      :item-text="`name`"
                      hide-details
                      dense
                      :readonly="!isNew"
                    />
                  </td>
                </tr>

                <tr>
                  <td style="width: 100px">
                    <strong>Ship No</strong>
                  </td>
                  <td>
                    <v-autocomplete
                      v-model="itemDetail.shipno"
                      :items="listShip"
                      :item-value="`code`"
                      :item-text="`name`"
                      hide-details
                      dense
                      :readonly="!isNew"
                    />
                  </td>
                </tr>
                <tr v-if="!isNew">
                  <td style="width: 100px">
                    <strong>Ship Name</strong>
                  </td>
                  <td>
                    <span>{{ itemDetail.shipnm }}</span>
                  </td>
                </tr>
                <tr>
                  <td style="width: 110px">
                    <strong>Start Time</strong>
                  </td>
                  <td>
                    <!-- <span>{{itemDetail.fday }}/{{itemDetail.fhhmm }}</span> -->
                    <div style="display: flex; justify-content: start;">
                      <v-dialog ref="dialog_from" v-model="modal_from" :return-value.sync="itemDetail.fday" persistent width="290px">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field v-model="itemDetail.fday" label="Date" :disabled="!isNew" v-bind="attrs" v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="itemDetail.fday" scrollable>
                          <v-btn text color="primary" @click="modal_from = false">
                            Cancel
                          </v-btn>
                          <v-btn text color="primary" @click="$refs.dialog_from.save(itemDetail.fday)">
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-dialog>

                      <v-dialog ref="dialog_ftime" v-model="modal_ftime" :return-value.sync="itemDetail.fhhmm" persistent width="290px">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="itemDetail.fhhmm"
                            label="Time"
                            prepend-icon="mdi-clock-time-four-outline"
                            :readonly="!isNew"
                            v-bind="attrs"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-time-picker v-if="modal_ftime" v-model="itemDetail.fhhmm" format="24hr" full-width>
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="modal_ftime = false">
                            Cancel
                          </v-btn>
                          <v-btn text color="primary" @click="$refs.dialog_ftime.save(itemDetail.fhhmm)">
                            OK
                          </v-btn>
                        </v-time-picker>
                      </v-dialog>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td style="width: 110px">
                    <strong>Finish Time</strong>
                  </td>
                  <td>
                    <!-- <span>{{itemDetail.tday }}/{{itemDetail.thhmm }}</span> -->
                    <div style="display: flex; justify-content: start;">
                      <v-dialog ref="dialog_to" v-model="modal_to" :return-value.sync="itemDetail.tday" persistent width="290px">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field v-model="itemDetail.tday" label="Date" readonly v-bind="attrs" v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="itemDetail.tday" scrollable>
                          <v-btn text color="primary" @click="modal_to = false">
                            Cancel
                          </v-btn>
                          <v-btn text color="primary" @click="$refs.dialog_to.save(itemDetail.tday)">
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-dialog>

                      <v-dialog ref="dialog_ttime" v-model="modal_ttime" :return-value.sync="itemDetail.thhmm" persistent width="290px">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="itemDetail.thhmm"
                            label="Time"
                            prepend-icon="mdi-clock-time-four-outline"
                            readonly
                            v-bind="attrs"
                            v-on="on"                            
                          ></v-text-field>
                        </template>
                        <v-time-picker v-if="modal_ttime" v-model="itemDetail.thhmm" format="24hr" full-width>
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="modal_ttime = false">
                            Cancel
                          </v-btn>
                          <v-btn text color="primary" @click="$refs.dialog_ttime.save(itemDetail.thhmm)">
                            OK
                          </v-btn>
                        </v-time-picker>
                      </v-dialog>
                    </div>
                  </td>
                </tr>                
                <tr>
                  <td style="width: 110px">
                    <strong>Oil Cons't</strong>
                  </td>
                  <td>
                    <v-text-field label="Enter numbers only" v-model.trim="itemDetail.oiltime"  @keypress="onlyNumber" hide-details dense />
                    <!-- <span>{{itemDetail.oiltime}}</span> -->
                  </td>
                </tr>
                <tr>
                  <td style="width: 100px">
                    <strong>Place</strong>
                  </td>
                  <td>
                    <div style="display: flex; justify-content: start;">
                      <v-autocomplete v-model="itemDetail.fjangso" :items="listPlace" :item-value="`code`" :item-text="`name`" hide-details dense />
                      <v-autocomplete v-model="itemDetail.tjangso" :items="listPlace" :item-value="`code`" :item-text="`name`" hide-details dense />
                    </div>

                    <!-- <span>{{itemDetail.fjangso}} ~ {{itemDetail.tjangso}}</span> -->
                  </td>
                </tr>
                <tr>
                  <td style="width: 100px">
                    <strong>Bunker</strong>
                  </td>
                  <td>
                    <!-- <span>{{itemDetail.bunker}}</span> -->
                    <v-text-field label="Enter numbers only" v-model.trim="itemDetail.bunker"  @keypress="onlyNumber" hide-details dense />
                  </td>
                </tr>
                <tr>
                  <td style="width: 100px">
                    <strong>Purpose</strong>
                  </td>
                  <td>
                    <v-autocomplete
                      v-model="itemDetail.mcode"
                      :items="listPurpose"
                      :item-value="`code`"
                      :item-text="`name`"
                      hide-details
                      dense
                    />
                    <!-- <span>{{ itemDetail.mcode }}</span> -->
                  </td>
                </tr>
                <tr>
                  <td style="width: 100px">
                    <strong>Fuel oil</strong>
                  </td>
                  <td>
                    <v-autocomplete
                      v-model="itemDetail.fueloil"
                      :items="listFuelOil"
                      :item-value="`code`"
                      :item-text="`name`"
                      hide-details
                      dense
                    />
                    <!-- <span>{{ itemDetail.mcode }}</span> -->
                  </td>
                </tr>
                <tr>
                  <td style="width: 100px">
                    <strong>Remark</strong>
                  </td>
                  <td>
                    <!-- <span v-if="!isNew" >{{ itemDetail.rmk }}</span> -->
                    <v-text-field v-model.trim="itemDetail.rmk" hide-details dense /> 
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-sheet>
      </v-card>
    </v-dialog>
    <!-- End of detailed dialog -->
    <!-- Scroll To Top -->
    <v-btn small v-scroll="onScroll" v-show="fab" fab dark fixed bottom right color="primary" @click="toTop">
      <v-icon>mdi-chevron-up</v-icon>
    </v-btn>
  </v-expansion-panels>
</template>

<script>
import { copyTugboat, 
         tugBoatCnt, 
         getAlreadyConfirm, 
         getEmpNo, 
         getPurpose, 
         getPlace, 
         getShipNo, 
         getTugBoat, 
         search5000List, 
         save01, 
         delete1, 
         confirmSign 
       } from '@/api/view/pp/20/v20a5000.js'

import { DxScrollView } from 'devextreme-vue/scroll-view'
import { DxPopup } from 'devextreme-vue/popup'
import ICardVertical from '@/components/common/iCardVertical.vue'
import iCardTop from '@/components/common/iCardTop.vue'
import DxDateBox from 'devextreme-vue/date-box'
import baseview from '@/components/base/baseview.vue' // base page addition
import BaseDataGrid from '@/components/base/BaseDataGrid.vue' // Add base when using data grid
import notify from 'devextreme/ui/notify' // message
import { getDateFormat, getCurrentDate } from '@/utils/common.js'
import dayjs from 'dayjs'
import moment from 'moment'
import { fn_uni2vni, fn_vni2uni } from '@/api/view/pp/common/common.js'
import EventBus from '@/components/event-bus'

export default {
  name: 'v20a5000m',
  mixins: [baseview, BaseDataGrid],

  components: {
    DxPopup,
    ICardVertical,
    'i-card-top': iCardTop,
    DxDateBox,
    DxScrollView
    // AppButton,
  },
  props: {},
  data: () => ({
    openedPanel: 0,
    cOpenedPanel: -1,
    txtFilter: '',

    menuTitle: '', //this.$route.meta.title,
    useBtnList: ['btnRetrieve', 'btnAdd'], //,'btnAdd','btnSave', , 'btnDelete'
    selected: [0],
    fab: false,
    dark: false,

    //Date
    modal_from: '',
    modal_to: '',

    fday: '',
    tday: '',
    //Time select
    fhhmm: null,
    thhmm: null,
    modal_ftime: false,
    modal_ttime: false,

    listShip: [],
    listRShip: [],
    cboShipNo: '',

    cboTugBoat: '',
    cboTugBoatCopy: '',
    listTugBoat: [],

    cboFjangso: '',
    cboTjangso: '',
    listPlace: [],
    listPurpose: [],
    listFuelOil: [
        {code: 'M', name: 'Ship moving'},
        {code: 'S', name: 'Support'},
      ],
    movDate: moment().format('YYYY-MM-DD'),
    fdate: moment().format('YYYY-MM-DD'),
    tdate: moment().format('YYYY-MM-DD'),
    gridMainList: [],
    listSize: 0,
    showDetail: false,
    oriItem: {},
    itemDetail: {},
    isNew: false,

    empCaption: '',
    btnCaption: false,
    empChief: '',
    btnChief: false,
    countChief: 0,
    countCaption: 0,
    countAll: 0,
    writeYn: 'N',
     rules: {
      onlyNumbers: value => /^\d+$/.test(value) || "Enter numbers only!"
    }
  }),

  created() {
    // console.log("created: "+this.$options.name + "_search");
    EventBus.$on(this.$options.name + '_search', () => {
      this.btnSearch()
    })
  },

  mounted() {
    
    this.writeYn = this.$gUtil.getWriteYn()
    // console.log("writeYn: ", this.writeYn );
    this.btnCaption = false
    this.btnChief   = false
    this.setCombo()
  },

  beforeDestroy() {
    this.writeYn = this.$gUtil.getWriteYn()
    // console.log("beforeDestroy: "+this.$options.name + "_search");
    EventBus.$off(this.$options.name + '_search')
  },

  computed: {
    filteredItems: function() {
      return this.$gUtil.executeFilter(this.gridMainList, this.txtFilter)
    },
    tugBoat: function() {
      const items = this.listTugBoat.filter(item => item.code && item.code === this.cboTugBoat)
      return items.length > 0 ? items[0].name : 'ALL'
    },
    tugBoatCopy: function() {
      const items = this.listTugBoat.filter(item => item.code && item.code === this.cboTugBoatCopy)
      return items.length > 0 ? items[0].name : 'ALL'
    },
    // shipNo: function() {
    //     const items = this.listShip.filter(item => item.code && item.code === this.cboShipNo);
    //     return items.length > 0 ? items[0].name : "ALL";
    // },
  },

  methods: {
    onScroll(e) {
      if (typeof window === 'undefined') return
      const top = window.pageYOffset || e.target.scrollTop || 0
      this.fab = top > 20
    },
    toTop() {
      this.$vuetify.goTo(0)
    },

    onlyNumber(event) {//@keypress="onlyNumber"
      const charCode = event.which ? event.which : event.keyCode;
      if (charCode < 48 || charCode > 57) {
        event.preventDefault();
      }
    },
    filterNumber() {//@input="filterNumber"
      this.numberValue = this.numberValue.replace(/\D/g, ""); // Chỉ giữ lại số
    },
    btnSearch() {
      this.gridMainList = []
      this.doSearchMainList()
    },
    getStrFormat(date) {
      return getDateFormat(date)
    },

    async setCombo() {
      // this.openLoading('Đang tìm')

      let params = { tugNo: '' }

      //getPurpose
      const purpose = async () => {
        await getPurpose(params).then(result => {
          this.listPurpose = result.list
          // result.list.forEach(item => {
          //   this.listPurpose.push({
          //     name: item.name,
          //     code: item.code
          //   })
          // })
        })
      }
      // getShipNo
      const ship = async () => {
        await getShipNo(params).then(result => {
          // console.log("####res.list", res.list);
          this.listShip = result.list
          // this.listRShip = JSON.parse(JSON.stringify(result.list));
          // this.listShip.splice(0, 0, { code: "%", name: "ALL" });
        })
      }

      // getTugBoat
      const tugboat = async () => {
        await getTugBoat(params).then(result => {
          // console.log("####result.list", res.list);
          this.listTugBoat = result.list
          // this.listTugBoat.splice(0, 0, { code: "%", name: "ALL" });
        })
      }

      // getTugBoat
      const place = async () => {
        await getPlace(params).then(result => {
          // console.log("####result.list", res.list);
          this.listPlace = result.list
          // this.listPlace.splice(0, 0, { code: "%", name: "ALL" });
        })
      }

      this.$qLoading.show()

      await Promise.all([ship(), tugboat(), place(), purpose()])
        .catch(ex => {
          //    this.$qMsgBox.show(this, this.$gUtil.getSqlError(ex), ['ok']);
        })
        .finally(() => {
          this.$qLoading.hide()
        })
    },

    btnCopy(){

          if (!this.cboTugBoatCopy) {
            this.vToastify(this.$t('Please, select Tug-Boat To.'), 'warn')
            return
          }

          let params = {
                tugNo: this.cboTugBoat,
                tugNoCopy: this.cboTugBoatCopy,
                moveDate: this.movDate,
                userId: this.$store.state.user.userId,
            }

          tugBoatCnt(params).then(result => {
            // console.log('===>result: ', result.body);
                if(result.body > 0){
                    this.vToastifyPrompt(
                        this.$t('Do you want to OVERWRITE?'),
                        'info',
                        current => {
                            this.openLoading('Loading...')
                            copyTugboat(params)
                                .then(res => {                         
                                  notify(this.$t('Data was copied successfully!'), 'success', 3000)
                                    
                                })
                                .catch(error => {
                                    // this.vToastify(this.$t('Có lỗi xảy ra trong khi cập nhật dữ liệu.'), 'warn')
                                    notify(error, 'error', 1500)
                                    this.endLoading()
                                })
                                .finally(() => {   
                                    this.doSearchMainList()                        
                                    this.endLoading()
                                })
                        },
                        null,
                        true
                    )   
                }else{
                   try{
                        this.openLoading('searching')
                        copyTugboat(params).then(res => {
                          // console.log('res', res)
                         notify(this.$t('Data was copied successfully!'), 'success', 3000)
                        })
                        .catch(error => {
                          this.vToastify(error, 'warn')
                          this.endLoading()
                        })
                        .finally(() => {
                          this.doSearchMainList()
                        })
                      } finally{
                        this.endLoading()
                      }
                }
            })
    },
    async btnChiefConfirm() {

      if (this.gridMainList.length === 0){
        this.vToastify(this.$t('No data to confirm!.'), 'warn')
        return
      }else{
        let params = {
                tugNo: this.cboTugBoat,
                moveDate: this.movDate,                
                authDiv: 'TI22',
                userId: this.empChief,
            }
           
            this.vToastifyPrompt(
                this.$t('Do you want to sure confirm?'),
                'info',
                current => {
                    this.openLoading('Loading...')
                    confirmSign(params)
                        .then(res => {                         
                           notify(this.$t('Confirmed successfully!'), 'success', 3000)
                            
                        })
                        .catch(error => {
                            // this.vToastify(this.$t('Có lỗi xảy ra trong khi cập nhật dữ liệu.'), 'warn')
                            notify(error, 'error', 1500)
                            this.endLoading()
                        })
                        .finally(() => {   
                            this.doSearchMainList()                        
                            this.endLoading()
                        })
                },
                null,
                true
            )
        // notify(this.$t('Confirmed successfully!'), 'success', 3000)
      }
      
    },
    async btnCaptionConfirm() {
      
      if (this.gridMainList.length === 0){
        this.vToastify(this.$t('No data to confirm!.'), 'warn')
        return
      }else{

        let params = {
                tugNo: this.cboTugBoat,
                moveDate: this.movDate,                
                authDiv: 'TI21',
                userId: this.empCaption,
            }
                 
            this.vToastifyPrompt(
                this.$t('Do you want to sure confirm?'),
                'info',
                current => {
                    this.openLoading('Loading...')
                    confirmSign(params)
                        .then(res => {
                         
                           notify(this.$t('Confirmed successfully!'), 'success', 3000)
                            
                        })
                        .catch(error => {
                            // this.vToastify(this.$t('Có lỗi xảy ra trong khi cập nhật dữ liệu.'), 'warn')
                            notify(error, 'error', 1500)
                            this.endLoading()
                        })
                        .finally(() => {   
                            this.doSearchMainList()                        
                            this.endLoading()
                        })
                },
                null,
                true
            )

        // notify(this.$t('Confirmed successfully!'), 'success', 3000)
      }
    },
    async doSearchMainList() {
      try {
        this.openLoading('Loading...')
        
        if (!this.cboTugBoat) {
          this.vToastify(this.$t('Please, select Tug-Boat No.'), 'warn')
          return
        }

        let params = {
          tugNo: this.cboTugBoat,
          moveDate: this.movDate
        }

        // console.log('######doSearchMainList--params===>', params)
        //Check Caption/ Chief engineer already confirm or not?
        this.getConfirmed(this.cboTugBoat, this.movDate)

        await search5000List(params).then(res => {

          if (res.list.length > 0) {
            this.gridMainList = res.list
            this.listSize = res.list.length            
            this.openedPanel = 1
            // this.setSign(this.cboTugBoat)  
            // console.log('res', res.list.length);
          } else {
            this.gridMainList.splice(0)
             this.listSize = 0
            // notify('No Data', 'error', 5000)
            // this.vToastify(this.$t('No Data.'), 'warn')
            // this.$gUtil.showToast(this, 'No Data!')
          }
          this.setSign(this.cboTugBoat)  
          // console.log('######listSize===>', this.gridMainList)
        })
      } finally {
        this.endLoading()
      }
    },

    getConfirmed(tugno, mDate){
     
      // console.log('mDate', mDate);
      // get Employee Caption
      let params1 = { tugNo: tugno, authDiv: '1', moveDate: mDate}
      getAlreadyConfirm(params1).then(res => {
          this.countCaption = res.list.length
          //  console.log('countCaption', this.countCaption);
      }) 

      // get Employee Chief Engineer
      let params2 = { tugNo: tugno, authDiv: '2', moveDate: mDate }
      getAlreadyConfirm(params2).then(res => {
          this.countChief = res.list.length
          // console.log('countChief', this.countChief);
      })

      // get Employee confirm All
      let params3 = { tugNo: tugno, authDiv: '3', moveDate: mDate }
      getAlreadyConfirm(params3).then(res => {
          this.countAll = res.list.length
          // console.log('countAll', this.countAll);
      })
    },

    setSign(e){
      //  console.log('setSign: ',  e);
      // get Employee Caption
      let params1 = { tugNo: e, authDiv: '1' }
      getEmpNo(params1).then(res => {          
          this.empCaption = res.list[0].empno
          // console.log(' this.empCaption',  this.empCaption);
          if ((this.empCaption === this.$store.state.user.userId)&&(this.gridMainList.length > 0)&&(this.countCaption === 0)&&(this.countChief > 0)){
            this.btnCaption = true
            // console.log(' this.btnCaption',  this.btnCaption);
          }
          else{
            this.btnCaption = false
          }
      }) 

      // get Employee Chief Engineer
      let params2 = { tugNo: e, authDiv: '2' }
      getEmpNo(params2).then(res => {          
          this.empChief = res.list[0].empno
          // console.log(' this.empChief',  this.empChief);
          if ((this.empChief === this.$store.state.user.userId)&&(this.gridMainList.length > 0)&&(this.countChief === 0)&&(this.countCaption === 0)){
            this.btnChief = true
            //  console.log(' this.btnChief',  this.btnChief);
          }
          else{
            this.btnChief = false
          }
      })
    },
    btnAdd() {
      // console.log('######countCaption===>', this.countCaption)
      // console.log('######countChief===>', this.countChief)
      if (!this.cboTugBoat) {
        this.vToastify(this.$t('Please, select Tug-Boat No to Add.'), 'warn')
        return
      }

      if (this.countCaption > 0 ) {
        this.vToastify(this.$t('This Tug-Boat already confirmed by Caption!'), 'warn')
        return
      }

      this.isNew = true
      this.btnResetClick()
      this.showDetail = true
      this.itemDetail.tugno = this.cboTugBoat
      this.itemDetail.fday = this.movDate
      this.itemDetail.tday = this.movDate
    },
    btnSave() {
      //  console.log('######btnSave===>', this.itemDetail)
      //Using
      // if (this.itemDetail.captionYN ==='Y' || this.itemDetail.chiefYN === 'Y') {
      //   this.vToastify('This Tug-Boat already confirmed!', 'warn')
      //   return
      // }

      if (!this.itemDetail.tugno || !this.itemDetail.shipno) {
        this.vToastify(this.$t('requiredCheck') + '[Ship No]', 'warn')
        return
      }

      if (!this.itemDetail.fday) {
        this.vToastify(this.$t('requiredCheck') + '[start date]', 'warn')
        return
      }

      if (!this.itemDetail.tday) {
        this.vToastify(this.$t('requiredCheck') + '[Finish date]', 'warn')
        return
      }

      if (!this.itemDetail.fhhmm.replace(":", "")||this.itemDetail.fhhmm.replace(":", "")==='') {
        this.vToastify(this.$t('requiredCheck') + '[Start time]', 'warn')
        return
      }
      
      if (!this.itemDetail.thhmm.replace(":", "")||this.itemDetail.thhmm.replace(":", "")==='') {
        this.vToastify(this.$t('requiredCheck') + '[Finish time]', 'warn')
        return
      }

      if (this.itemDetail.fday > this.itemDetail.tday) {
        this.vToastify('Shift finish date must be greater than shift start date!', 'warn')
        return
      }

      if ((this.itemDetail.fday === this.itemDetail.tday)&&(this.itemDetail.fhhmm.replace(":", "") > this.itemDetail.thhmm.replace(":", ""))) {
        this.vToastify('Shift finish time must be greater than shift start time!', 'warn')
        return
      }     
      if ((this.itemDetail.fhhmm.replace(":", "")).length != 4) {
        this.vToastify('Please input shift start time correctly!', 'warn')
        return
      }
      if ((this.itemDetail.thhmm.replace(":", "")).length != 4) {
        this.vToastify('Please input shift finish time correctly!', 'warn')
        return
      }

      if(((this.itemDetail.fhhmm.replace(":", "")).substr(0,2) >= '00')&&((this.itemDetail.fhhmm.replace(":", "")).substr(0,2) <= '24')){
        if(((this.itemDetail.fhhmm.replace(":", "")).substr(3,1) >= '0')&&((this.itemDetail.fhhmm.replace(":", "")).substr(3,1) <= '6')){
        
        }else{
          this.vToastify('Please check shift start time!', 'warn')
          return
        }
      }else{
          this.vToastify('Please check shift start time!', 'warn')
          return
      }

      if(((this.itemDetail.thhmm.replace(":", "")).substr(0,2) >= '00')&&((this.itemDetail.thhmm.replace(":", "")).substr(0,2) <= '24')){
        if(((this.itemDetail.thhmm.replace(":", "")).substr(3,1) >= '0')&&((this.itemDetail.thhmm.replace(":", "")).substr(3,1) <= '6')){
        
        }else{  
          this.vToastify('Please check shift finish time!', 'warn')
          return
        }
      }else{
          this.vToastify('Please check shift finish time!', 'warn')
          return
      }

      const param = {
                  seq: this.itemDetail.seq !=null ? this.itemDetail.seq: 1 + '',
                  tugno: this.itemDetail.tugno,
                  shipno: this.itemDetail.shipno,
                  fday: this.itemDetail.fday,
                  fhhmm: this.itemDetail.fhhmm.replace(":", ""),
                  tday: this.itemDetail.tday,
                  thhmm: this.itemDetail.thhmm.replace(":", ""),
                  fjangso: this.itemDetail.fjangso !=null?this.itemDetail.fjangso:'',
                  tjangso: this.itemDetail.tjangso !=null?this.itemDetail.tjangso:'',
                  bunker: this.itemDetail.bunker !=null?this.itemDetail.bunker:'',
                  mcode: this.itemDetail.mcode !=null?this.itemDetail.mcode:'',
                  rmk: this.itemDetail.rmk !=null?this.itemDetail.rmk:'',
                  fueloil: this.itemDetail.fueloil !=null?this.itemDetail.fueloil:'',
                  oiltime: this.itemDetail.oiltime !=null?this.itemDetail.oiltime:'',
                  userId: this.$store.state.user.userId,

                  __modified__: this.isNew === true ? false: true,
                  __created__: this.isNew === true ? true :false,
                }

        // console.log('######param===>', param)  
         try{
              this.openLoading('searching')
              save01(param).then(result => {
                // console.log('result', result)
                this.itemDetail = result.map.retValue;                
                if (this.isNew) {
                  this.isNew = false;
                  this.itemDetail = result.map.retValue;
                  this.oriItem = JSON.parse(JSON.stringify(this.itemDetail));
                  this.gridMainList.splice(0, 0, this.oriItem);
                }
                else {
                  this.oriItem.tday = result.map.retValue.tday !=null?result.map.retValue.tday:'';
                  this.oriItem.thhmm = result.map.retValue.thhmm!=null?result.map.retValue.thhmm:'';
                  this.oriItem.fjangso = result.map.retValue.fjangso !=null?result.map.retValue.fjangso:'';
                  this.oriItem.tjangso = result.map.retValue.tjangso !=null?result.map.retValue.tjangso:'';
                  this.oriItem.bunker = result.map.retValue.bunker !=null?result.map.retValue.bunker:'';
                  this.oriItem.mcode = result.map.retValue.mcode !=null?result.map.retValue.mcode:'';
                  this.oriItem.rmk = result.map.retValue.rmk !=null?result.map.retValue:'';
                  this.oriItem.fueloil = result.map.retValue.fueloil!=null?result.map.retValue.fueloil:'';
                  this.oriItem.oiltime = result.map.retValue.oiltime !=null?result.map.retValue.oiltime:'';
                  this.oriItem.userId = result.map.retValue.userId !=null?result.map.retValue.userId:'';
                  this.oriItem.seq = result.map.retValue.seq !=null?result.map.retValue.seq:'';

                  this.oriItem.__modified__ = result.map.retValue.__modified__;
                  this.oriItem.__created__ = result.map.retValue.__created__;
                }
                this.showDetail = false
                notify('Saved', 'success', 3000)

              })
              .catch(error => {
                this.vToastify(error, 'warn')
                this.endLoading()
              })
              .finally(() => {
                this.btnSearch()
              })
            } finally{
              this.endLoading()
            }       
    },

    async btnDelete(item) {
      // console.log('######btnDelete===>', item.shipno)

      if (item.captionYN ==='Y' || item.chiefYN === 'Y') {
        this.vToastify('You cant not delete! This Tug-Boat already confirmed!', 'warn')
        return
      }

      const param = {                 
                  tugno: item.tugno,
                  shipno: item.shipno,
                  fday: item.fday,
                  fhhmm: item.fhhmm.replace(":", ""),
                }
        // console.log('######param===>', param)  
         try{
              this.openLoading('searching')
              delete1(param).then(result => {
                // console.log('result', result)                
                notify('Deleted', 'success', 3000)

              })
              .catch(error => {
                this.vToastify(error, 'warn')
                this.endLoading()
              })
              .finally(() => {
                this.btnSearch()
              })
            } finally{
              this.endLoading()
            } 
    },

    listItemClick(item) {
      // console.log('######listItemClick===>', item.shipno)
      this.isNew = false
      this.oriItem = item
      this.itemDetail = JSON.parse(JSON.stringify(item))
      this.showDetail = true
    },

    uppercase() {
      this.block = this.block.toUpperCase()
    },

    btnResetClick() {
      this.isNew = true

      this.oriItem = {}
      this.itemDetail = {}
    }
  }
}
</script>
<style></style>
